import { http } from 'vue'

export default {
  loadCompanies (context, params) {
    const page = params.page || 1
    const perPage = params.perPage || 20

    if (params.reset) context.commit('CLEAR_COMPANIES')

    http.get('companies' + '?sort=company_name&page=' + page + '&per_page=' + perPage)
      .then((response) => {
        context.commit('SAVE_COMPANIES', response.data.data)
      }, (response) => {
        console.log('error: Loading companies resource from API')
      })
  },
  // load company
  loadCompany (context, params = {}) {
    let withParam = params.with ? '?with=' + params.with : ''
    return http.get('companies/' + params.id + withParam)
  },
  saveCompanies (context, payload) {
    context.commit('SAVE_COMPANIES', payload)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/companies/actions.js